import { render, staticRenderFns } from "./#mail-detail-list.vue?vue&type=template&id=a36937f2&"
import script from "./#mail-detail-list.vue?vue&type=script&lang=js&"
export * from "./#mail-detail-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports